import { Result } from '@hereisyourgitanton/core';
import { Observable, map } from 'rxjs';
import { SealedTradingCommandPort, UpsertSealedBidPayload, SealedBid } from '@tradgine/sealed-auction-trade';
import { inject } from '@angular/core';
import { BidAuctionSealedFlow } from '@tradgine/data-access/auction-sealed-flow';
import { toSealedBid } from '../mappers/mappers';

export class SealedTradingCommandAdapter implements SealedTradingCommandPort {
    private readonly bidApi = inject(BidAuctionSealedFlow);

    upsertBid(payload: UpsertSealedBidPayload): Observable<Result<SealedBid, Error>> {
        return this.bidApi.placeBid(payload).pipe(
            map((result) =>
                result
                    .map((bidDto) => toSealedBid(bidDto, payload.auctionId))
                    .mapErr(() => new Error($localize`:@@sealed-auction.error.upsert-bid:Failed to upsert bid`))
            )
        );
    }

    deleteBid(bidId: number): Observable<Result<void, Error>> {
        return this.bidApi.deleteBid(bidId).pipe(
            map((result) => result.map(() => void 0).mapErr(() => new Error($localize`:@@sealed-auction.error.delete-bid:Failed to delete bid`)))
        );
    }
}

